import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const FiatDepositAppeal = () => {
  const [currency, setCurrency] = useState("");
  const [method, setMethod] = useState("");
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState("");
  const [transactionId, setTransactionId] = useState("");

  return (
    <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
<Header />

   <div className="mx-auto lg:p-6 p-3 max-w-2xl">
     <div className="flex flex-col items-center justify-center py-10">
      {/* Title */}
      <h1 className="text-3xl font-semibold flex justify-center mb-16">Fiat Deposit Appeal</h1>

      {/* Step Progress */}
      <div className="lg:flex block justify-between w-full mb-4 px-6">
                
            <div className="font-medium">Currency and payment method</div>
            <div className="text-gray-400 font-medium">Bank Information</div>
       
      </div>

      {/* Form Card */}
      <div className="shadow-md rounded-lg lg:p-6 p-3 w-full">
        {/* Currency */}
        <label className="block mb-2 font-medium">Currency</label>
        <select
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
          className="w-full border rounded-lg px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-yellow-400 bg-transparent"
        >
          <option value="">Select Currency</option>
          <option value="USD">USD</option>
          <option value="INR">INR</option>
          <option value="EUR">EUR</option>
        </select>

        {/* Payment Method */}
        <label className="block mb-2 font-medium">Select a payment method</label>
        <div className="lg:flex lg:space-x-3 mb-4">
          <button
            type="button"
            onClick={() => setMethod("bank")}
            className={`flex items-center space-x-2 border rounded-lg px-4 py-2 lg:w-1/2 w-full justify-center ${
              method === "bank"
                ? "border-yellow-500 bg-yellow-50 text-black"
                : "border-gray-300"
            }`}
          >
            <span>🏦</span>
            <span>Bank Transfer</span>
          </button>
          <button
            type="button"
            onClick={() => setMethod("card")}
            className={`flex items-center space-x-2 border rounded-lg px-4 py-2 lg:w-1/2 w-full justify-center mt-2 lg:mt-0 ${
              method === "card"
                ? "border-yellow-500 bg-yellow-50 text-black"
                : "border-gray-300"
            }`}
          >
            <span>💳</span>
            <span>Credit Card</span>
          </button>
        </div>

        {/* Amount */}
        <label className="block mb-2 font-medium">Amount</label>
        <input
          type="number"
          placeholder="Please enter exact amount you have transferred"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400 bg-transparent"
        />
        <p className="mb-6 text-gray-500 text-sm pl-1 mt-1">Please enter exact amount you have transferred</p>
        {/* Transaction Date */}
        <label className="block mb-2 font-medium">Transaction Date</label>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="w-full border rounded-lg px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-yellow-400 bg-transparent"
        />

        {/* Transaction ID */}
        <label className="block mb-2 font-medium">
          Transaction ID (if any)
        </label>
        <input
          type="text"
          placeholder="Enter transaction ID (if any)"
          value={transactionId}
          onChange={(e) => setTransactionId(e.target.value)}
          className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400 bg-transparent"
        />
            <p className="mb-6 text-gray-500 text-sm pl-1 mt-1">Select the date you initiated the transfer</p>
        {/* Submit Button */}
        <button className="w-full bg-yellow-400 text-black font-medium rounded-lg py-2 hover:bg-yellow-500">
          Next
        </button>
      </div>
    </div>
   </div>
    <Footer />
    </div>
  );
};

export default FiatDepositAppeal;
